import { Box, Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { FirstTimeTour } from 'src/constants/productTour/FirstTimeTour';
import {
  reducerResetTourSteps,
  reducerUpdateButtonTour,
  reducerUpdateNextTourSteps,
  reducerUpdateOnTour
} from 'src/features/productTour';

interface Props {
  children?: any;
  placement?:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start'
    | undefined;
  open?: boolean;
  backgroundColor?: string;
  color?: string;
  arrowColor?: string;
  maxWidth?: number;
  onClick?: () => void;
  opacity?: number;
  hideArrow?: boolean;
  onClose?: () => void;
}

const ProductTourTooltip: React.FC<Props> = ({
  children,
  placement = 'left',
  open,
  backgroundColor = 'white',
  color = 'black',
  arrowColor = 'white',
  maxWidth = 600,
  onClick = null,
  opacity = 1,
  hideArrow = false,
  onClose = null
}) => {
  const dispatch = useAppDispatch();
  const { stepNumber, totalStep, currentStep, menu } = useAppSelector(
    (state) => state.storeProductTour.currentTour
  );

  return (
    <Tooltip
      arrow={!hideArrow}
      placement={placement}
      title={
        <React.Fragment>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography fontWeight="bold" color={color}>
              {currentStep.title}
            </Typography>
            <Typography
              color="#9D9D9C"
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                localStorage.removeItem('isFirstTime');
                dispatch(reducerUpdateOnTour(false));
                dispatch(reducerResetTourSteps());
                if (onClose) {
                  onClose();
                }
              }}
            >
              x
            </Typography>
          </Stack>
          {currentStep.content}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={1}
            sx={{ marginTop: '12px' }}
          >
            {currentStep.showNextButton ? (
              <Box
                sx={{
                  backgroundColor: '#0B85AE',
                  padding: '8px',
                  cursor: 'pointer',
                  borderRadius: '4px',
                  '&:hover': {
                    opacity: 0.5
                  }
                }}
                onClick={() => {
                  if (menu === FirstTimeTour.menu && stepNumber === totalStep) {
                    dispatch(reducerUpdateOnTour(false));
                    dispatch(reducerResetTourSteps());
                    dispatch(reducerUpdateButtonTour(false));
                    localStorage.removeItem('isFirstTime');
                  } else {
                    dispatch(reducerUpdateNextTourSteps());
                    if (onClick) {
                      onClick();
                    }
                  }
                }}
              >
                <Typography fontSize="12px" fontWeight="600" color="white">
                  {currentStep.nextButtonText}
                </Typography>
              </Box>
            ) : (
              <div></div>
            )}
            <Typography color="#9D9D9C" fontSize="12px" textAlign="right">
              {stepNumber}/{totalStep}
            </Typography>
          </Stack>
        </React.Fragment>
      }
      open={open}
      componentsProps={{
        arrow: {
          sx: { color: arrowColor }
        },
        tooltip: {
          sx: {
            backgroundColor,
            color,
            padding: 2,
            maxWidth
          }
        },
        popper: {
          open,
          style: {
            opacity
          }
        }
      }}
    >
      {children}
    </Tooltip>
  );
};

export default ProductTourTooltip;
